import LOG from "services/loggingService";

// Create a singleton to manage the cooldown state
const AudioPlayerCooldownHandler = (function () {
    let lastExecutionTime = 0;
    const COOLDOWN_PERIOD = 2 * 60 * 1000; // 2 minutes in milliseconds

    return {
        canExecute: function () {
            const currentTime = new Date().getTime();

            if (currentTime - lastExecutionTime < COOLDOWN_PERIOD) {
                LOG.info(
                    "Skipping stalled event handling - cooldown period active"
                );
                return false;
            }
            return true;
        },
        updateExecutionTime: function () {
            lastExecutionTime = new Date().getTime();
        },
        // Add reset method for testing
        reset: function () {
            lastExecutionTime = 0;
        },
    };
})();

export default AudioPlayerCooldownHandler;
